declare const centerecoParams: {
    nonce: string;
    ajaxUrl: string;
};

import { popupToggle, debounce, popupClose } from "./functions";

const iconNext: string = '<span class="icon icon_md"><svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33334 1.33329L8 7.99996L1.33333 14.6666L0.150001 13.4833L5.63333 7.99996L0.150002 2.51663L1.33334 1.33329Z"></path></svg></span>';
const orderPopup = document.querySelector('.popup_order');

const calc: HTMLElement = document.querySelector('.calc') as HTMLElement;
const prevButton: HTMLButtonElement = calc.querySelector('.calc__prev') as HTMLButtonElement;
const nextButton: HTMLButtonElement = calc.querySelector('.calc__next') as HTMLButtonElement;
const servicesButtons: NodeListOf<HTMLButtonElement> = calc.querySelectorAll('.calc__service-btn');
const calcTitle: HTMLElement = calc.querySelector('.calc__title') as HTMLElement;
const progressbarPercentage: HTMLElement = calc.querySelector('.progressbar__percentage') as HTMLElement;
const progressbarFill: HTMLElement = calc.querySelector('.progressbar__fill') as HTMLElement;
const calcContainer = calc.querySelector('.calc__content') as HTMLElement | null;
const calcServices = calc.querySelector('.calc__services') as HTMLElement | null;

let selectedService: HTMLButtonElement | null = null;
let currentStage: 1 | 2 = 1;

const serviceElements: Record<string, { title: string, genitive: string, slug: string }> = {
    ekologicheskie: {
        title: 'Экологические изыскания',
        genitive: 'Экологических изысканий',
        slug: 'ekologicheskie'
    },
    geodezicheskie: {
        title: 'Геодезические изыскания',
        genitive: 'Геодезических изысканий',
        slug: 'geodezicheskie'
    },
    geologicheskie: {
        title: 'Геологические изыскания',
        genitive: 'Геологических изысканий',
        slug: 'geologicheskie'
    },
    gidrometeorologicheskie: {
        title: 'Гидрометеорологические изыскания',
        genitive: 'Гидрометеорологических изысканий',
        slug: 'gidrometeorologicheskie'
    }
};

// Creating an object with forms for quick access
const forms: Record<string, HTMLFormElement | null> = {
    ekologicheskie: document.getElementById('form-ekologicheskie') as HTMLFormElement | null,
    geodezicheskie: document.getElementById('form-geodezicheskie') as HTMLFormElement | null,
    geologicheskie: document.getElementById('form-geologicheskie') as HTMLFormElement | null,
    gidrometeorologicheskie: document.getElementById('form-gidrometeorologicheskie') as HTMLFormElement | null
};

const handleButtonClickDebounced = debounce((move: 'next' | 'prev') => handleButtonClick(move), 100);


// Service selection
servicesButtons.forEach(button => {
    button.addEventListener('click', () => {
        servicesButtons.forEach(btn => btn.classList.remove('calc-service-btn_active'));
        button.classList.add('calc-service-btn_active');
        selectedService = button;
        nextButton.disabled = false;
    });
});

// Navigation
function handleButtonClick(move: 'next' | 'prev'): void {
    if (currentStage === 1 && move === 'next') {
        const serviceType = selectedService?.getAttribute('data-service') as string;

        if (serviceType && serviceElements[serviceType]) {
            const formToShow = forms[serviceType];

            if (calcContainer && formToShow) {
                // Remove the active class from all forms and add it only to the selected one
                Object.values(forms).forEach(form => form?.classList.remove('calc__form_active'));
                formToShow.classList.add('calc__form_active');

                // Move the form block to the container
                calcContainer.innerHTML = '';
                calcContainer.append(formToShow);

                // Update the title and progress bar
                calcTitle.textContent = `Расчет стоимости ${serviceElements[serviceType].genitive.toLowerCase()}`;
                progressbarFill.style.width = '100%';
                progressbarPercentage.textContent = '100%';
                nextButton.innerHTML = 'Завершить';
                nextButton.disabled = true;
                prevButton.disabled = false;
                currentStage = 2;

                // Remove the active class from the service selection block
                if (calcServices) {
                    calcServices.classList.remove('calc__services_active');
                }
            } else {
                console.error("Форма не найдена или контейнер не инициализирован.");
            }
        } else {
            console.error("Неизвестный тип услуги: ", serviceType);
        }
    } else if (currentStage === 2 && move === 'prev') {
        resetCalculator();
    } else if (currentStage === 2 && move === 'next') {
        // Check if popup needs to be closed
        // if (nextButton.innerHTML.includes('Завершить')) {}
        if (orderPopup) {
            popupToggle('order');
            const currentForm: HTMLFormElement = calc.querySelector('.calc__form_active');
            const targetForm: HTMLFormElement = orderPopup.querySelector('.popup__form');

            if (currentForm && targetForm) {
                const hiddenClass = 'calc-hidden-field';
                // remove old hidden fiedls
                const existingHiddenFields = targetForm.querySelectorAll(`input[type="hidden"].${hiddenClass}`);
                existingHiddenFields.forEach(field => field.remove());
                // get current fields from calc
                const formElements = currentForm.querySelectorAll<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>('input:not([type="hidden"]), textarea, select');
                // add new hidden fiedls
                formElements.forEach(element => {
                    const hiddenField = document.createElement('input');
                    hiddenField.type = 'hidden';
                    hiddenField.name = element.name;
                    hiddenField.value = (element as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement).value;
                    hiddenField.classList.add(hiddenClass);
                    targetForm.appendChild(hiddenField);
                });
                // update data-value for orderService input
                const serviceType = selectedService?.getAttribute('data-service') as string;
                const orderServiceInput = targetForm.querySelector('input[name="orderService"]') as HTMLInputElement;
                if (orderServiceInput && serviceType) {
                    orderServiceInput.value = serviceElements[serviceType].title;
                }
            }
        } else {
            popupClose(null);
        }
        setTimeout(() => resetCalculator(), 500);
    }
}

function resetCalculator(): void {
    if (calcContainer) {
        calcContainer.innerHTML = '';

        if (calcServices) {
            // Add the service selection block
            calcContainer.append(calcServices);
        }
    }

    calcTitle.textContent = 'Выберите интересуемый раздел услуг';
    progressbarFill.style.width = '10%';
    progressbarPercentage.textContent = '0%';
    nextButton.innerHTML = 'Далее' + iconNext;
    nextButton.disabled = true;
    prevButton.disabled = true;
    currentStage = 1;
    selectedService?.classList.remove('calc-service-btn_active');

    // Remove the active class from all forms & reset his
    Object.values(forms).forEach(form => {
        if (form) {
            form.classList.remove('calc__form_active');
            form.reset();
            const resultElement = form.querySelector('.calc-form__result span') as HTMLSpanElement;
            resultElement.textContent = '0 руб.';

            const sliders: NodeListOf<HTMLInputElement> = form.querySelectorAll('.range__slider');
            sliders.forEach(slider => {
                slider.value = '3';
                slider.style.setProperty('--value', '3');

                const ticks = form.querySelectorAll('.range__span');
                ticks.forEach((tick, index) => {
                    if (index === 2) {
                        tick.classList.add('range__span_active');
                    } else {
                        tick.classList.remove('range__span_active');
                    }
                });
            });
        }
    });

    // Add the active class to the service selection block
    if (calcServices) {
        calcServices.classList.add('calc__services_active');
    }
}

prevButton.addEventListener('click', () => handleButtonClickDebounced('prev'));
nextButton.addEventListener('click', () => handleButtonClickDebounced('next'));




// ? validate forms
function isFormFilled(form: HTMLFormElement): boolean {
    const inputs = form.querySelectorAll('input[type="number"]');
    return Array.from(inputs).every(input => (input as HTMLInputElement).value.trim() !== '');
}

async function sendCalculationRequest(data: FormData) {
    try {
        const response = await fetch(centerecoParams.ajaxUrl, {
            method: 'POST',
            body: data,
        });

        const result = await response.json();
        data.forEach((value, key) => {
            console.log(`${key}: ${value}`);
        });
        return result;
    } catch (error) {
        console.error('Ошибка отправки запроса:', error);
        return null;
    }
}


const handleFormInput = debounce(async (event: Event) => {
    const form: HTMLFormElement = (event.target as HTMLInputElement).closest('form');

    if (!form || !isFormFilled(form)) {
        if (form) {
            nextButton.disabled = true;
            const resultElement = form.querySelector('.calc-form__result span') as HTMLSpanElement;
            resultElement.textContent = '0 руб.';
        }
        return;
    }

    nextButton.disabled = false;

    const formData = new FormData(form);
    formData.append('action', 'handle_calculator');
    formData.append('nonce', centerecoParams.nonce);

    const result = await sendCalculationRequest(formData);
    const resultElement = form.querySelector('.calc-form__result span') as HTMLSpanElement;
    if (result && result.total) {
        resultElement.textContent = `${result.total.toLocaleString()} руб.`;
    } else {
        resultElement.textContent = '0 руб.';
    }
}, 300);

Object.values(forms).forEach(form => {
    if (form) {
        form.addEventListener('input', handleFormInput);
    }
});